<template>
  <div
    class="table-search-container"
  >
  
    <a-select
      style="width:200px;"
      class="select-container"
      placeholder="请选择状态"
      @change="value => $emit('onChangeStatus', value)"
    >
      <a-select-option
        v-for="item in statusData"
        :key="item.id"
        :value="item.id"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>
    <a-input-search
      placeholder="请输入搜索内容"
      style="width:225px;margin-right:20px;"
      @search="value => $emit('onSearch', value)"
    />

    <a-select placeholder="请选择合作企业" v-model="companyId"  style="width: 225px; margin-right:0px;"   @change="value => $emit('onChangecompany', value)">
    <a-select-option v-for="item in companyData" :key="item.id" :value="item.id">
      {{ item.companyInfo.qichacha_name }}
    </a-select-option>
  </a-select>
  
    <a-button
      style="margin:0;"
      type="primary"
      shape="round"
      icon="plus"
      @click="$emit('editAndAdd')"
    >
      新增视频
    </a-button>
  </div>
</template>
<script>
export default {
  data() {
    return {
		companyData: [],
		companyId:'',
      statusData: [
        {id: -1, name: '全部'},
        {id: 1, name: '已发布'},
        {id: 2, name: '未发布'},
        {id: 3, name: '已置顶'},
        {id: 4, name: '未置顶'},
        {id: 5, name: '已推荐'},
        {id: 6, name: '未推荐'},
      ],
    };
  },
   mounted() {
   
     this.getCompanyList();
   
  },
  methods: {
	// 获取合作企业
	async getCompanyList() {
	  let result = await this.$http.post('/Company/getCooperationCompanyList');
	  if (result.data.status === 1) {
	   this.companyData = result.data.data.data_list;
	   this.companyId=this.companyData[0].id
	  }
	},
  },
};
</script>
<style lang="scss">
.table-search-container {
  height: 70px;
  line-height: 70px;
  .ant-input {
    border-radius: 15px;
    height: 30px;
  }
  .ant-btn-round {
    font-size: 12px;
    height: 30px;
    padding: 0 17px;
    border-radius: 15px;
    margin-left: 20px;
  }
  .ant-select-selection{
    margin-right: 20px;
  }
}
</style>
